import React from 'react';
import { ListTodo, AlertTriangle } from 'lucide-react';
import { formatCSTTime, calculateDuration } from '../../utils/time';
import { ActiveTask } from '../../types/time';
import { useLanguageStore } from '../../store/languageStore';
import translations from '../../translations';

interface StatusDisplayProps {
  currentShift: {
    clockin_time: number;
    finishjob_time?: number;
    clockout_time?: number;
  } | null;
  activeTasks: ActiveTask[];
  onViewTasks: () => void;
}

export function StatusDisplay({ currentShift, activeTasks, onViewTasks }: StatusDisplayProps) {
  const { language } = useLanguageStore();
  const t = translations[language].timeTracker;

  if (!currentShift) return null;

  const clockInTime = new Date(currentShift.clockin_time);
  const finishJobTime = currentShift.finishjob_time
    ? new Date(currentShift.finishjob_time)
    : null;
  const clockOutTime = currentShift.clockout_time
    ? new Date(currentShift.clockout_time)
    : null;

  return (
    <div className="space-y-4 text-gray-700 dark:text-gray-300">
      <div>
        <p className="font-medium">{t.time.clockInTime}:</p>
        <p className="text-lg">{formatCSTTime(clockInTime)}</p>
      </div>

      {finishJobTime && (
        <div>
          <p className="font-medium">{t.time.jobFinishTime}:</p>
          <p className="text-lg">{formatCSTTime(finishJobTime)}</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t.time.duration}:{' '}
            {calculateDuration(
              currentShift.clockin_time,
              currentShift.finishjob_time!
            )}
          </p>
        </div>
      )}

      {clockOutTime && (
        <div>
          <p className="font-medium">{t.time.clockOutTime}:</p>
          <p className="text-lg">{formatCSTTime(clockOutTime)}</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">
            {t.time.totalDuration}:{' '}
            {calculateDuration(
              currentShift.clockin_time,
              currentShift.clockout_time
            )}
          </p>
        </div>
      )}

      {activeTasks.length > 0 && (
        <div className="bg-yellow-50 dark:bg-yellow-900/20 text-yellow-800 dark:text-yellow-200 p-4 rounded-lg border border-yellow-200 dark:border-yellow-800 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 flex-shrink-0" />
            <div>
              <p className="font-medium">{t.tasks.activeTasks.replace('{count}', activeTasks.length.toString())}</p>
              <p className="text-sm mt-1">{t.actions.completeActiveTasks}</p>
            </div>
          </div>
          <button
            onClick={onViewTasks}
            className="btn-secondary flex items-center gap-2 text-sm"
          >
            <ListTodo className="h-4 w-4" />
            {t.actions.viewTasks}
          </button>
        </div>
      )}
    </div>
  );
}